import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const WorkerCustomReports =
  (APIData) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        data: APIData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        },
        url: `${actionType.environment_url}/api/admin/worker/HandleCustomReports`,
      });
      return response.data;
    } catch (error) {
      return error.message;
    }
  };


  export const FetchAllWorkerCustomReports = (apidata) => async (dispatch) => {
    /*** API Call Action ***/
    try {
      const response = await axios({
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        },
        url: `${actionType.environment_url}/api/admin/worker/GetAllCustomReports`,
        params: apidata, 
      });
  
      return response.data;  
    } catch (error) {
      console.error("Error in Worker GetAllfavouriteReports:", error);  
      return { error: error.message };  
    }
  };